import { VideoTexture } from 'three';
import Image from './Image';
import TexturesController from './TexturesController';

export default class Video extends Image {
    constructor(opts = {}) {
        super(opts);
    }

    loadTexture() {
        const video = this.dom.querySelector('video');
        video.crossOrigin = 'anonymous';

        const poster = this.dom.dataset.poster || this.dom.getAttribute("poster");
        const mask = this.dom.dataset.mask;

        if (poster) {
            TexturesController.load({
                src: poster,
                material: this.material.uniforms.texture1,
                attribute: "value"
            });
        }

        if (mask) {
            TexturesController.load({
                src: mask,
                material: this.material.uniforms.mask,
                attribute: "value"
            });
        }

        const _play = () => {
            video.removeEventListener('play', _play);
            this.texture = new VideoTexture(video);
            this.material.uniforms.texture1.value = this.texture;
        }
        video.addEventListener('play', _play);
    }

    play() {
        this.dom.play();
    }

    pause() {
        this.dom.pause();
    }

    dispose() {
        this.texture.dispose();
        super.dispose();
    }
}
